<div class="flex w-full">
  <lib-side-navigation [items]="sideNavigationItems" />
  <div class="w-full flex flex-col">
    <lib-navigation-header />
    <main class="w-full h-full bg-blue-gray-100 relative">
      <div class="px-[24px] py-[30px]">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
